<template>
  <div class="apple-callback-container">
    <div class="loading-spinner">
      <i class="el-icon-loading" style="font-size: 40px;"></i>
      <p>正在处理 Apple 登录...</p>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'AppleCallback',
  async created() {
    await this.handleAppleCallback()
  },
  methods: {
    async handleAppleCallback() {
      try {
        // Apple 使用 form_post 方式返回，code 在 URL 参数或 POST body 中
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const state = urlParams.get('state')
        const error = urlParams.get('error')
        
        // 检查错误
        if (error) {
          console.error('Apple callback error:', error)
          this.$message.error('Apple 登录失败：' + error)
          this.$router.replace('/login')
          return
        }
        
        // 检查 code
        if (!code) {
          console.error('No authorization code received')
          this.$message.error('未收到授权码')
          this.$router.replace('/login')
          return
        }
        
        // 验证 state（防止 CSRF）
        const savedState = sessionStorage.getItem('apple_login_state')
        if (savedState && savedState !== state) {
          console.error('State mismatch')
          this.$message.error('安全验证失败')
          this.$router.replace('/login')
          return
        }
        
        // 清除 state
        sessionStorage.removeItem('apple_login_state')
        
        // 调用后端接口，用 code 换取 token
        const response = await api.post('/auth/apple-login-web', { code })
        
        if (response && response.token) {
          // 检查是否需要输入姓名
          if (!response.customerName) {
            let fullName = ''
            try {
              const { value } = await this.$prompt('请输入您的姓名', '完善信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputPattern: /\S+/,
                inputErrorMessage: '姓名不能为空'
              })
              fullName = value
            } catch (e) {
              // 用户取消，继续登录流程
            }
            
            if (fullName) {
              await api.put('/auth/update-name', { customerName: fullName })
              response.customerName = fullName
            }
          }
          
          // 处理登录成功
          await this.handleLoginSuccess(response)
        } else {
          throw new Error('未获取到登录凭证')
        }
        
      } catch (error) {
        console.error('Apple callback error:', error)
        this.$message.error('Apple 登录失败：' + (error.message || '未知错误'))
        this.$router.replace('/login')
      }
    },
    
    async handleLoginSuccess(response) {
      // 存储 token
      if (response.token) {
        localStorage.setItem('auth_token', response.token)
      }
      
      // 存储用户信息
      if (response.username) {
        localStorage.setItem('username', response.username)
      }
      
      // 存储 customerId（档口ID）
      if (response.customerId) {
        localStorage.setItem('stored_customer_id', response.customerId.toString())
      }
      
      // 检查是否需要选择角色
      if (response.roleOptions && response.roleOptions.length > 1) {
        // 多角色，跳转到角色选择页面
        this.$router.replace({
          path: '/role-select',
          query: {
            roles: JSON.stringify(response.roleOptions),
            username: response.username
          }
        })
        return
      }
      
      // 单角色或无角色，直接跳转
      let redirectPath = '/'
      if (response.roleOptions && response.roleOptions.length === 1) {
        const role = response.roleOptions[0]
        localStorage.setItem('user_role', role.roleCode)
        
        switch (role.roleCode) {
          case 'ADMIN':
            redirectPath = '/admin/dashboard'
            break
          case 'WHOLESALER':
            redirectPath = '/wholesaler/home'
            break
          case 'STALL':
          case 'CUSTOMER':
            redirectPath = '/stall/home'
            break
          case 'DRIVER':
            redirectPath = '/driver/home'
            break
          default:
            redirectPath = '/'
        }
      }
      
      // 检查 URL 中的 redirect 参数
      const urlRedirect = this.$route.query.redirect
      if (urlRedirect) {
        redirectPath = urlRedirect
      }
      
      this.$message.success('登录成功')
      this.$router.replace(redirectPath)
    }
  }
}
</script>

<style scoped>
.apple-callback-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f5f7fa;
}

.loading-spinner {
  text-align: center;
  color: #606266;
}

.loading-spinner p {
  margin-top: 16px;
  font-size: 16px;
}
</style>
